export default __webpack_public_path__ + "static/media/fondo.2ce54860.jpg";